import AuthHeader from "@/features/auth/components/AuthHeader";
import { useCreateEvent } from "@/features/events/hooks/useCreateEvent";
import { EventType } from "@/features/events/types/EventType";
import AuthPageLayout from "@/features/platform-layout/components/AuthPageLayout";
import { useEffect } from "react";
import LoadingSpinner from "../../../../components/LoadingSpinner";
import NewPasswordBox from "../components/NewPasswordBox";
import { useNewPassword } from "../hooks/useNewPassword";

const NewPassword = () => {
    const { onBackButtonClick, handleInputsSubmit, isLoading } = useNewPassword()
    const { sendEvent } = useCreateEvent()

    useEffect(() => {
        void sendEvent({
            event: EventType.PAGE_VIEW,
            sub_category: "change_password_page",
        })
    }, [])

    // ********************************************************************************

    return (
        <AuthPageLayout>
            <AuthHeader
                onBackClick={onBackButtonClick}
            />
            <div className="w-full flex-1 flex flex-col items-center justify-center mt-[80px] overflow-hidden ">
                <div className="w-full sm:w-[328px] md:w-[400px] lg:w-[500px] p-[20px] bg-white">
                    <NewPasswordBox
                        onSubmit={handleInputsSubmit}
                    />
                </div>
            </div>
            {
                isLoading && <div className="w-full h-full div-center absolute"><LoadingSpinner /></div>
            }
        </AuthPageLayout>
    )
}

export default NewPassword
